export const HTTP_STATUS_CODES = {
  FORBIDDEN: 403
};
